import IMAGES from "@/public/assets/img";
import Image from "next/image";

const FreightExporterChallenge = ({ challenge }) => {
  return (
    <section className="bg-[#f0f7ff] my-[100px] sm:my-20 relative sm:pt-6">
      <div className="container px-3 lg:px-3 xm:px-2">
        <div className="flex justify-between gap-6 mt-3 items-center sm:flex-col">
          <div className="w-[45%] sm:w-full h-full md:py-4">
            <h3 className="text-textxl font-semibold text-[#072F5F]">
              {challenge.subSectionTitle}
            </h3>
            <p className="text-baseBlack text-lg font-normal mt-2">
              {challenge.subSectionDescription}
            </p>
            <ul className="mt-4 space-y-4">
              {challenge.benefits.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <Image
                    src={item.icon}
                    alt="Benefit icon"
                    width={24}
                    height={24}
                    className="mt-1"
                    priority={true}
                  />
                  <span className="text-baseBlack text-lg sm:text-base font-medium">
                    {item.text}
                  </span>
                </li>
              ))}
            </ul>
          </div>
          {/* Right Side Image */}
          <div className="w-1/2 sm:w-full h-full sm:pt-4">
            <Image
              src={IMAGES?.FreightLoan.stockContainer}
              alt="Industrial plant"
              width={600}
              height={550}
              className="object-cover"
              priority={true}
            />
          </div>
        </div>
        </div>
    </section>
  );
};

export default FreightExporterChallenge;
